import React from 'react'
import MiniCarouselInsuranceConected from './MiniCarouselConnected'
import { getInsuranceMiniCardsFromAlgoliaResults } from '../../domain/useCases/insurance/getInsuranceMiniCardsFromAlgoliaResults'

const MiniCarouselInsuranceFilter = ({
  feedPosition,
  id,
  isUnitedStatesCount,
  location,
  locationSlug,
  pageType,
  searchState,
  title
}) => {
  const miniCarouselInsuranceFilterProps = {
    feedPosition,
    id,
    isUnitedStatesCount,
    location,
    locationSlug,
    pageType,
    searchState,
    title,
    transformItemsToCards: getInsuranceMiniCardsFromAlgoliaResults,
    attribute: 'accepted_insurance',
    taxonomyType: 'accepted_insurance',
    label: 'Insurance',
    operator: 'and'
  }

  return <MiniCarouselInsuranceConected {...miniCarouselInsuranceFilterProps} />
}

export default MiniCarouselInsuranceFilter
